module.exports = __webpack_public_path__ + "static/img/restaurant-filter-icon02.bcb3cafb.svg";